/**
 * @author Matthew Rogers
 */
var upclBind = { changelog: '<', bod: '<' };
var UserEditChangeLogController = (function () {
    function UserEditChangeLogController(Dialog) {
        this.Dialog = Dialog;
    }
    ;
    UserEditChangeLogController.prototype.viewLog = function (event) {
        var items = {
            logdata: this.changelog,
            bod: this.bod,
            viewEntries: [],
            expand: function (num) {
                if (this.viewEntries.indexOf(num) > -1) {
                    this.viewEntries.splice(this.viewEntries.indexOf(num), 1); //lose
                }
                else {
                    this.viewEntries.push(num);
                }
            },
            columnHeaders: ['Date Updated', 'by Admin User']
        };
        this.Dialog.openDialog(event, items, DialogService, 'user.edit-changelog-view.html');
    };
    UserEditChangeLogController.$inject = ['Dialog'];
    return UserEditChangeLogController;
}());
var UserEditChangeLogComponent = (function () {
    function UserEditChangeLogComponent() {
        this.bindings = upclBind;
        this.templateUrl = 'user.edit-changelog.html';
        this.controller = UserEditChangeLogController;
    }
    return UserEditChangeLogComponent;
}());
angular
    .module('application')
    .component('userChangeLog', new UserEditChangeLogComponent());

//# sourceMappingURL=user.edit-changelog.component.js.map
